import React from "react";
import PropTypes from "prop-types";

const ListItem = ({ offer }) => {
  return (
    <nobr>
      <span className="List_item"> {offer}</span>
    </nobr>
  );
};

ListItem.propTypes = {
  offer: PropTypes.string.isRequired,
};

export default ListItem;
